import React, { useEffect } from "react";
import { createPortal } from "react-dom";

const LegalModal = ({ open, onClose, type }) => {

  // 🔒 Disable background scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  // ⚡ Electric text effect
  useEffect(() => {
    if (!open) return;

    const container = document.querySelector(".electric-container");
    if (!container) return;

    const textNodes = container.querySelectorAll("p, h1, h2, li");

    textNodes.forEach((node) => {
      if (node.dataset.electricized) return;

      const text = node.innerText;
      node.innerHTML = "";

      [...text].forEach((char, i) => {
        const span = document.createElement("span");
        span.innerText = char === " " ? "\u00A0" : char;
        span.style.transitionDelay = `${i * 8}ms`;
        node.appendChild(span);
      });

      node.dataset.electricized = "true";
    });
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="legal-overlay" onClick={onClose}>
      <div
        className="legal-modal electric-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="legal-close" onClick={onClose}>
          ✕
        </button>

        {/* ========== TERMS & CONDITIONS ========== */}
        {type === "terms" && (
          <>
            <h1>Terms & Conditions</h1>
            <p><em>Last updated: 2 Jan 2026</em></p>

            <h2>1. Scope of Work</h2>
            <p>
              ANTI9five provides website development, lead systems, automation,
              and basic CRM setup services only.
            </p>
            <p>
              Mobile applications, custom software, ERP systems, or large-scale
              platforms are not included unless explicitly agreed upon in writing.
            </p>

            <h2>2. Project Understanding</h2>
            <p>
              All work is carried out strictly based on the scope agreed during
              onboarding.
            </p>
            <p>
              Any request outside the agreed scope will be treated as additional
              work and may involve extra charges.
            </p>

            <h2>3. No Guaranteed Leads or Revenue</h2>
            <p>ANTI9five does not guarantee leads, sales, or revenue.</p>
            <p>
              We guarantee only the proper setup of systems designed to capture,
              respond to, and manage leads efficiently.
            </p>

            <h2>4. Advertising & Marketing</h2>
            <p>
              Paid advertisements (Meta, Google, etc.) are not included by default.
            </p>
            <p>
              Advertising services, if required, are handled separately or via
              partners. Ad spend is always paid directly by the client.
            </p>

            <h2>5. Tools & Platform Costs</h2>
            <p>
              All third-party tools such as domains, hosting, WhatsApp API, CRM
              subscriptions, or upgrades are paid directly by the client.
            </p>
            <p>
              Recurring subscription costs are not included in setup fees.
            </p>

            <h2>6. Advance Payment Policy</h2>
            <p>
              A non-refundable advance payment of <strong>31%</strong> of the total
              project cost is required before project initiation.
            </p>

            <div className="legal-highlight">
              <strong>
                A non-refundable advance payment of 31% is mandatory before project initiation.
              </strong>
            </div>

            <h2>7. WhatsApp Automation Limitation</h2>
            <p>
              Automation using the WhatsApp Business App has functional limitations.
            </p>
            <p>
              Advanced automation requires WhatsApp API integration and may involve
              additional setup and message charges paid by the client.
            </p>

            <h2>8. Client Responsibilities</h2>
            <ul>
              <li>Providing accurate business information</li>
              <li>Giving timely approvals and feedback</li>
              <li>Managing and responding to leads</li>
            </ul>

            <h2>9. Timelines & Delays</h2>
            <p>
              Project timelines depend on timely inputs and approvals from the client.
            </p>
            <p>
              Delays in response may extend the delivery timeline.
            </p>

            <h2>10. Payment & Support Policy</h2>
            <p>
              Final payment must be completed before project handover or go-live.
            </p>
            <p>
              Post-delivery support includes basic guidance only. Ongoing maintenance
              or changes require a separate support plan.
            </p>

            <hr />

            <p>
              By continuing communication, making payment, or proceeding with
              ANTI9five services, the client acknowledges and agrees to these
              Terms & Conditions.
            </p>


            <center>
              <p>&copy; 2026 Anti9five. Built & managed by Sam.</p>
            </center>
            <div className="legal-footer-actions">
  <button className="legal-exit-btn" onClick={onClose}>
    ← Back
  </button>
</div>
          </>
        )}

        {/* ========== PRIVACY POLICY (placeholder) ========== */}
        {type === "privacy" && (
  <>
    <h1>Privacy Policy</h1>
    <p><em>Last updated: 2 Jan 2026</em></p>

    <p>
      This Privacy Policy explains how ANTI9five collects, uses, and protects your
      information.
    </p>

    <h2>1. Information We Collect</h2>
    <p>
      We may collect basic information such as your name, phone number, email address,
      business details, and any information you voluntarily share via forms, WhatsApp,
      or email. We do not collect sensitive personal data.
    </p>

    <h2>2. How We Use Your Information</h2>
    <p>
      Your information is used only to respond to inquiries, provide services,
      communicate about projects, and improve internal processes.
      We do not sell or misuse your data.
    </p>

    <h2>3. Data Sharing</h2>
    <p>
      ANTI9five does not sell, rent, or trade your personal information.
      Data may be shared only with trusted third-party tools strictly for service delivery.
    </p>

    <h2>4. Cookies & Tracking</h2>
    <p>
      We may use basic cookies or analytics tools to understand usage and improve
      user experience. These tools do not collect personally identifiable information.
    </p>

    <h2>5. Data Security</h2>
    <p>
      We take reasonable measures to protect your information.
      However, no online system is 100% secure.
    </p>

    <h2>6. Third-Party Tools</h2>
    <p>
      We may use hosting platforms, email services, form tools, or automation systems.
      Each third-party service follows its own privacy policies.
    </p>

    <h2>7. Your Rights</h2>
    <p>
      You may request access, correction, or deletion of your data at any time
      by contacting us directly.
    </p>

    <h2>8. Policy Updates</h2>
    <p>
      This Privacy Policy may be updated occasionally.
      Changes will be reflected on this page with an updated date.
    </p>

    <h2>9. Contact Information</h2>
    <p>
      Email: kannectwithsam@gmail.com
      <br />
      Brand: ANTI9five
    </p>
<hr />

    <center>
      <p>&copy; 2026 Anti9five. Built & managed by Sam.</p>
    </center>
    <div className="legal-footer-actions">
  <button className="legal-exit-btn" onClick={onClose}>
    ← Back
  </button>
</div> 
  </>
)}


      </div>
    </div>,
    document.body
  );
};

export default LegalModal;
